module.exports = __webpack_public_path__ + "static/media/case-pelesys-1.e7c5612f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-pelesys-1.jpg
// module id = 85
// module chunks = 3